export const RXModule = "rxModule";
export const VideoVisit = "videoVisit";
export const EVisit = "eVisit";
export const ProviderSearch = "providerSearch";
export const LocationSearch = "locationSearch";
export const InsuranceModule = "insuranceModule";
export const BehavioralHealthTriage = "behavioralHealthTriage";
export const FAQ = "faq";
export const OnlineAppointmentScheduling = "onlineAppointmentScheduling";
export const Wellness = "wellness";
export const PricingTransparency = "pricingTransparency";
export const SDCVideoVisit = "sdcVideoVisit";
export const ThriveModule = "thrive";
export const AmbulatoryVideoVisit = "ambulatoryVideoVisit";
export const ChatBot = "chatBot";
export const FluShot = "fluShot";
export const Amity = "amity";
export const InHomeVaccine = "inHomeVaccinationScheduling";
export const Lyra = "lyra";